import clsx from 'clsx'
import React from 'react'
import Select from 'react-select'
import {isFieldEmpty} from '../../../helpers/utils'

const types = {checkbox: Checkbox, textarea: Textarea, panel: Panel, dropdown: Dropdown, radiopanel: RadioPanel}


function Dropdown (props) {
  const {name, count, grouped, value, options, context} = props
  const selects = value.filter(val => val != '').map((val, index) => { 
    const label = value.length < 2 ? name : `${name} ${index + 1}`
    return (
      <div key={index} className="select">
        {!grouped && name && (<label>{label}</label>)}
        <div className="control">
          {val || " "}
        </div>
      </div>)
 })
  return (
    <div>
      {grouped && (<label>{name}</label>)}
      {selects}
    </div>
  )
}

function Checkbox (props) {
  const {context} = props
  return (
    <div>
      <label>
        <input
          type="checkbox"
          checked={props.value}
          readOnly={true}
        />
        {props.name}
      </label>
    </div>
  )
}

function Textarea (props) {
  const {context, name, maxlength, value, id, panelId, contentId} = props
  return (
    <div>
      <label>{name}</label>
      <div className="textarea">
        {value}
      </div>
    </div>
  )
}

function Panel (panelProps) {
  const {id, name, context} = panelProps
  const children = panelProps.children
    .map((props, contentId) => ({props, Element: types[props.type], contentId}))
    .filter(({Element, props}) => Element && !isFieldEmpty(props))
    .map(({Element, props, contentId}, index) => (
      <Element
        key={index}
        id={id}
        panelId={panelProps.contentId}
        contentId={contentId}
        context={context}
        {...props}
      />))

  return (
    <div>
      {children.length > 0 && (
        <React.Fragment>
          <label>{name}</label>
          <div className="children">
            {children}
          </div>
        </React.Fragment>)}
    </div>
  )
}

function RadioPanel (panelProps) {
  const {id, name, context} = panelProps
  const children = panelProps.children
    .filter(props => props.name === panelProps.value)
    .map((props, contentId) => {

      const radioId = `${id}-radio-${contentId}`
      const checked = panelProps.value === props.name
      const children = checked && props.value
        .filter(props => props.value)
        .map((props, index) => {
          return (
            <div key={index} className={clsx("radio-panel-option", {checked})}>
              <label>
                <input
                  type="checkbox"
                  checked={props.value || false}
                  readOnly={true}
                />
                {props.name}
              </label>
            </div>
          )
      })

      return (
        <div className={clsx("radio-panel-item", {checked})} key={contentId}>
          <input
            id={radioId}
            type="radio"
            name={id}
            checked={checked}
            readOnly={true}
            value={props.name}
          />
          <label htmlFor={radioId}>{props.name}</label>
          {children && children.length > 0 && (
            <div className="children">
              {children}
            </div>
          )}
        </div>
      )
    })
  return (
    <div>
      <label>{name}</label>
      <div className="children">
        {children}
      </div>
    </div>
  )
}

export default types
